import { request } from './request.js'

export const getWebSystems = () => request.get('web_systems')
